import { atom } from "jotai";
import { WorkSpace, WorkSpaceSettings } from "@/core/entities/workspace";

interface WorkspaceState {
  workspace: WorkSpace | null;
  settings: WorkSpaceSettings | null;
  userRoleNames: string[];
  isLoading: boolean;
  error: Error | null;
  hasWorkspace: boolean;
}

const initialState: WorkspaceState = {
  workspace: null,
  settings: null,
  userRoleNames: [],
  isLoading: true,
  hasWorkspace: false,
  error: null,
};

// Base atoms
export const workspaceAtom = atom<WorkspaceState>(initialState);

// Derived atoms for specific states
export const currentWorkspaceAtom = atom(get => get(workspaceAtom).workspace);

export const workspaceLoadingAtom = atom(get => get(workspaceAtom).isLoading);

export const workspaceErrorAtom = atom(get => get(workspaceAtom).error);

export const workspaceHasWorkspaceAtom = atom(get => get(workspaceAtom).hasWorkspace);

export const workspaceSettingsAtom = atom(get => get(workspaceAtom).settings);

export const workspaceUserRoleNamesAtom = atom(get => get(workspaceAtom).userRoleNames);
